import React from 'react';
import FeatureRichList from '../Common/RichList/FeatureRichList';

export const topUpSteps = [
	{
		id: 0,
		title: 'Tại giao diện chính, chọn icon “Nạp / Rút tiền”',
	},
	{
		id: 1,
		title: 'Chọn “Nạp tiền vào ví”',
	},
	{id: 2, title: 'Nhập số tiền cần nạp và nhấn “Tiếp tục”',},
	{
		id: 3, title: 'Xác nhận thông tin nạp tiền.',
		subtitle: ['Bạn có thể thay đổi nguồn nạp tiền bằng cách chọn “Thay đổi” <br/>Nguồn tiền là các ngân hàng bạn đã liên kết trước đó']
	},
	{id: 4, title: 'Nhập mật khẩu thanh toán để xác nhận giao dịch'},
];

export const topUpAccountInfoQrSteps = [
	{id: 0, title: 'Tại Trang chủ, chọn biểu tượng “Nạp/ Rút tiền”'},
	{id: 1, title: 'Chọn “Nạp tiền vào ví”'},
	{id: 2, title: 'Chọn “Chuyển khoản vào ví”'},
	{id: 3, title: 'Chọn “Tải ảnh” để tải mã QR chuyển khoản về thư viện ảnh'},
	{
		id: 4,
		title: 'Nội dung trong khung màu xanh là chính là thông tin tài khoản của bạn.',
		subtitle: ['Nhấn biểu tượng trong khung màu đỏ để sao chép số tài khoản ví GooPay của bạn.']
	},
];

export const topUpFromLinkedBankSteps = [
	{id: 0, title: 'Tại Trang chủ, chọn biểu tượng “Nạp/ Rút tiền”'},
	{id: 1, title: 'Chọn “Nạp tiền vào ví”'},
	{id: 2, title: 'Nhập số tiền cần nạp và nhấn “Tiếp tục”'},
	{
		id: 3,
		title: 'Xác nhận thông tin nạp tiền',
		subtitle: [
			'Bạn có thể thay đổi nguồn nạp tiền bằng cách chọn “Thay đổi”. Nguồn tiền là các ngân hàng bạn đã liên kết trước đó.'
		]
	},
	{id: 4, title: 'Nhập mã mở khóa Smart OTP để xác thực giao dịch'},
	{id: 5, title: 'Xác thực giao dịch bằng hình thức Smart OTP'},
	{id: 6, title: 'Nạp tiền thành công'},
];

export const topUpFromTransferQrSteps = [
	{id: 0, title: 'Tại Trang chủ, chọn biểu tượng “Nạp/ Rút tiền”'},
	{id: 1, title: 'Chọn “Nạp tiền vào ví”'},
	{id: 2, title: 'Chọn “Chuyển khoản vào ví”'},
	{id: 3, title: 'Chọn “Tải ảnh” để tải mã QR'},
	{
		id: 4,
		title: 'Truy cập ứng dụng ngân hàng của bạn và Chọn “Quét mã QR”',
		subtitle: [
			'Lưu ý : Mỗi ngân hàng sẽ có giao diện khác nhau, hãy chọn nút có biểu tượng: mã QR trên ứng dụng ngân hàng của bạn.'
		]
	},
	{
		id: 5,
		title: 'Chọn “Chọn từ Thư viện ảnh”',
		subtitle: [
			'Lưu ý : Mỗi ngân hàng sẽ có giao diện khác nhau, hãy chọn nút có biểu tượng: Thư viện ảnh trên ứng dụng ngân hàng của bạn.'
		]
	},
	{id: 6, title: 'Chọn ảnh mã QR mà bạn đã tải về máy'},
	{id: 7, title: 'Nhập số tiền bạn muốn nạp sau đó xác thực và hoàn thành nạp tiền vào ví GooPay'},
];

export const topUpFromTransferBankAppSteps = [
	{id: 0, title: 'Mở ứng dụng ngân hàng của bạn và chọn “Chuyển tiền”'},
	{
		id: 1,
		title: 'Chọn ngân hàng BIDV, và nhập thông tin tài khoản ví GooPay của bạn',
		subtitle: [
			'Để lấy thông tin tài khoản ví GooPay hoặc Tải ảnh mã QR ví GooPay hãy xem: Hướng dẫn lấy thông tin tài khoản và Mã QR chuyển khoản'
		]
	},
	{id: 2, title: 'Nhập số tiền bạn muốn nạp sau đó xác thực và hoàn thành nạp tiền vào ví GooPay'},
	{id: 3, title: 'Nạp tiền thành công, bạn có thể quay lại ví GooPay để kiểm tra số dư'},
];

const TopUpContent = ({setStep, step, isSHB, expandMore, data}) => {
	const steps = data ?? topUpSteps;
	return (
		<div className="w-full max-w-4xl py-4 px-2 md:px-4 mx-auto">
			<FeatureRichList data={steps} step={step} isSHB={isSHB} setStep={setStep} expandMore={expandMore} subClass='subClass'/>
		</div>
	);
};

export default TopUpContent;
